import { DEFAULT_MEDIA_DURATION } from 'consts'
import { FIT } from 'consts/canvas'
import { IDimensions } from 'types'
import { IMediaItem, MediaStatus } from 'types/media'
import { calculateMediaRect } from 'utils/media'

export const getTimestampWithinMediaItem = (
  mediaItem: IMediaItem,
  currentTimelineTime: number
) => {
  // calc relative timestamp within the media item on timeline taking into account the trim start
  const mediaStartTime = mediaItem.startTime
  const relativeTimestamp = currentTimelineTime - mediaStartTime
  const trimStart = mediaItem.meta.trimStart || 0
  const videoTimestamp = relativeTimestamp + trimStart

  // make sure timestamp is within media bounds
  const mediaDuration = mediaItem.meta.originalDuration || mediaItem.duration

  const clampedTimestamp = Math.max(
    trimStart,
    Math.min(videoTimestamp, mediaDuration)
  )
  return clampedTimestamp
}

export const getPlaceholderMediaItem = (
  startTime: number,
  defaultDimensions: IDimensions,
  activeMediaItem: IMediaItem
) => {
  // create placeholder item with fake dimensions and OK status to not show generation loading
  //mediabunny can take a time to process the frame, need to show item with loading
  const placeholderId = crypto.randomUUID()
  const FAKE_DIMENSIONS = {
    width: activeMediaItem.width || 100,
    height: activeMediaItem.height || 100
  }
  const placeholderMediaRect = calculateMediaRect({
    mediaDimensions: FAKE_DIMENSIONS,
    mode: FIT,
    canvasDimensions: defaultDimensions,
    rotation: 0
  })

  const coordinates = activeMediaItem.coordinates || {
    x: placeholderMediaRect.x || 0,
    y: placeholderMediaRect.y || 0
  }

  const placeholderItem: IMediaItem = {
    id: placeholderId,
    assetId: crypto.randomUUID(),
    type: 'image',
    width: FAKE_DIMENSIONS.width,
    height: FAKE_DIMENSIONS.height,
    duration: DEFAULT_MEDIA_DURATION,
    startTime,
    zIndex: activeMediaItem.zIndex,
    rotation: activeMediaItem.rotation,
    flip: activeMediaItem.flip,
    coordinates,
    meta: {
      path: null,
      originalWidth: activeMediaItem.meta.originalWidth,
      originalHeight: activeMediaItem.meta.originalHeight,
      status: MediaStatus.OK
    }
  }
  return placeholderItem
}
